// extracted by mini-css-extract-plugin
export default {"multisignConfirmTxLink":"jKa7oFIli4Co4LgjYgz5+g==","centerAlign":"iX+xHmlcGHfUg8Yh61EyUw==","sendBtnsWrapper":"XYjiNGdlNlRJ0eSkksbbaA==","actionBtn":"P08t2sy4JDkZVP0KT79C6Q=="};